import axios from "axios";
import { merge } from "lodash";
import { get_api_path } from "services/api";
import { store } from "../store";

export function sessioned_client(token) {
  const { localstore } = store.getState();
  const { access_token } = localstore;

  if (!token) {
    if (!access_token || !access_token.token)
      throw new Error("no access token");
    token = access_token.token;
  }

  const defaultOptions = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return {
    get: (url, options = {}) => axios.get(url, merge(defaultOptions, options)),
    post: (url, data, options = {}) => axios.post(url, data, merge(defaultOptions, options)),
    put: (url, data, options = {}) => axios.put(url, data, merge(defaultOptions, options)),
    delete: (url, options = {}) => axios.delete(url, merge(defaultOptions, options)),
  };
};

export async function login({ username, password }) {
  const url = get_api_path("account/login");
  const response = await axios.post(url, { username, password });
  const { access_token, account } = response.data.result;
  return { access_token, account };
};

export async function retrieve_profile(token) {
  const url = get_api_path("self/profile");
  const response = await sessioned_client(token).get(url);
  const { account } = response.data.result;
  return account;
};

export async function password_request({ email }) {
  const url = get_api_path("password/request");
  const response = await axios.post(url, { email });
  return response.data.result;
};

export async function password_query({ token }) {
  const url = get_api_path("password/query", { token });
  const response = await axios.get(url);
  return response.data.result;
};

export async function password_reset({ token, password }) {
  const url = get_api_path("password/reset");
  const response = await axios.post(url, { token, password });
  return response.data.result;
};